import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import MapDetails from "../../components/Manufacturer/MapDetails";
import { Typography } from "@mui/material";
import { ConnectorsTableApi } from "stores/ConnectorsTableStore/ConnectorsTableApi";
import MapSuccesful from "components/Manufacturer/Models/Mapsuccessfull";

class MapContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  submitPower = async (val) => {
    var res = await ConnectorsTableApi.postPowerMapApi({
      ...val,
      charger_type_id: this.props?.location?.ConnectorDetailsId?.id,
    });
    if (res.status === 1) {
      this.handleClickOpen();
    }
  };

  manufactureChange = (val) => {
    this.props.getSlectVehicleModelAction({ id: val });

    
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };

  componentDidMount() {
    this.props.getSlectVehicleAction({
      id: this.props.location.ConnectorDetailsId,
    });
   
  }

  render() {
    const selectlist = this.props?.SelectVehicleListdata?.result;
    const selecmodeltlist = this.props?.SelectVehicleModelListdata?.result;

    return (
      <Grid item xs={12}>
        <Stack p={0.5} mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link
              sx={{ fontSize: "14px" }}
              underline="hover"
              color="#A2A7AE"
              href="/manufacturer"
            >
              Manufacturer
            </Link>

            <Typography sx={{ fontSize: "14px" }} color="#0DA861">
              {this.props?.location?.ConnectorDetailsId?.name}
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid>
          <Paper sx={{ p: 3, mt: 1 }}>
            <MapDetails
              onClickModel={this.handleClickOpen}
              selectlist={selectlist}
              selecmodeltlist={selecmodeltlist}
              OnmanufactureChange={this.manufactureChange}
              submitPowerMap={(val) => this.submitPower(val)}
            />
          </Paper>

          <MapSuccesful handleClose={this.handleClose} open={this.state.open} />
        </Grid>
      </Grid>
    );
  }
}
export default MapContainer;
